export default __webpack_public_path__ + "static/media/cn.273fc2d5.svg";